export const HISTORYWORM_ORIGIN = 'https://www.historyworm.com';

export type HistorywormOutboundLink = {
  href: string;
  messageId: string;
  defaultMessage: string;
};

/** High-signal hub URLs for gastearsivi → historyworm cross-links (SEO discovery). */
export const historywormFooterHubLinks: HistorywormOutboundLink[] = [
  {
    href: `${HISTORYWORM_ORIGIN}/`,
    messageId: 'footer.historyworm.home',
    defaultMessage: 'History Worm — US newspaper archive',
  },
  {
    href: `${HISTORYWORM_ORIGIN}/arastirmalar`,
    messageId: 'footer.historyworm.research',
    defaultMessage: 'Research guides',
  },
  {
    href: `${HISTORYWORM_ORIGIN}/arastirma/chronicling-america-and-historyworm`,
    messageId: 'footer.historyworm.chroniclingAmerica',
    defaultMessage: 'Chronicling America companion',
  },
];

export const historywormHomepageHubLinks: HistorywormOutboundLink[] = [
  {
    href: `${HISTORYWORM_ORIGIN}/gazeteler`,
    messageId: 'index.historyworm_callout.gazeteler',
    defaultMessage: 'Browse all US newspapers',
  },
  {
    href: `${HISTORYWORM_ORIGIN}/yil/1920`,
    messageId: 'index.historyworm_callout.year1920',
    defaultMessage: '1920 newspaper archive',
  },
  {
    href: `${HISTORYWORM_ORIGIN}/gazete/evening_star`,
    messageId: 'index.historyworm_callout.eveningStar',
    defaultMessage: 'Evening Star archive',
  },
  {
    href: `${HISTORYWORM_ORIGIN}/arastirma/genealogy-newspaper-research`,
    messageId: 'index.historyworm_callout.genealogy',
    defaultMessage: 'Genealogy research guide',
  },
  {
    href: `${HISTORYWORM_ORIGIN}/arastirmalar`,
    messageId: 'index.historyworm_callout.research',
    defaultMessage: 'All research guides',
  },
];
